'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  domain: '',
  search: {
    placeholder: 'Search'
  },
  menuToggle: {
    label: 'MENU'
  },
  logo: {
    href: '/'
  },
  mainBtn: [{
    text: 'TEST DRIVE',
    classes: 'btn-ghost hidden-xs gold',
    link: '/free-trial'
  }, {
    text: 'LOGIN',
    classes: 'btn-ghost hidden-xs concur-blue',
    link: ''
  }],
  siteLinks: [{
    title: {
      text: 'PRODUCTS'
    },
    list: [{
      text: 'Expense products',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Concur Expense',
        src: '/expense-management'
      }, {
        text: 'Concur Detect by AppZen',
        src: '/detect-expense-fraud'
      }, {
        text: 'Concur Drive',
        src: '/concur-drive'
      }, {
        text: 'Budget',
        src: '/budget-management'
      }, {
        text: 'Concur Audit',
        src: '/expense-audit'
      }, {
        text: 'Concur Request',
        src: '/expense-approval-system'
      }, {
        text: 'Payment Solutions',
        src: '/payment-solutions'
      }, {
        text: 'Travel & Expense',
        src: '/travel-expense'
      }, {
        text: 'Company Bill Statements',
        src: '/p-card-reconciliation'
      }, {
        text: 'All products',
        src: '/all-products-page'
      }]
    }, {
      text: 'Travel products',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Concur Travel',
        src: '/travel-booking'
      }, {
        text: 'Concur Locate',
        src: '/concur-locate'
      }, {
        text: 'Budget',
        src: '/budget-management'
      }, {
        text: 'Concur TripLink',
        src: '/triplink'
      }, {
        text: 'TripLink Connected Suppliers',
        src: '/triplink-supplier-connections'
      }, {
        text: 'TripLink Travel Organization',
        src: '/triplink-travel-organization'
      }, {
        text: 'Travel & Expense',
        src: '/travel-expense'
      }, {
        text: 'All products',
        src: '/all-products-page'
      }]
    }, {
      text: 'Invoice products',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Concur Invoice',
        src: '/invoice-management'
      }, {
        text: 'All products',
        src: '/all-products-page'
      }]
    }, {
      text: 'Data insights',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Budget',
        src: '/budget-management'
      }, {
        text: 'Intelligence',
        src: '/business-intelligence'
      }, {
        text: 'Consultative Intelligence',
        src: '/travel-expense-data-analysis'
      }, {
        text: 'All products',
        src: '/all-products-page'
      }]
    }, {
      text: 'Support Offerings',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Service Administration',
        src: '/service-administration'
      }, {
        text: 'Support Desk',
        src: '/user-support-desk'
      }, {
        text: 'All products',
        src: '/all-products-page'
      }]
    }, {
      text: 'Integrations',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Platform',
        src: '/concur-integrated-ecosystem'
      }, {
        text: 'App Center',
        src: '/app-center'
      }, {
        text: 'All products',
        src: '/all-products-page'
      }]
    }, {
      text: 'All products',
      src: '/all-products-page'
    }, {
      text: 'Test Drive',
      src: '/free-trial',
      classes: 'call-out'
    }]
  }, {
    title: {
      text: 'SOLUTIONS'
    },
    list: [{
      text: 'For small business',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Concur Expense',
        src: '/small-business/expense'
      }, {
        text: 'Concur Invoice',
        src: '/small-business/invoice'
      }, {
        text: 'Concur Travel',
        src: '/travel-booking'
      }, {
        text: 'All solutions',
        src: '/small-business'
      }]
    }, {
      text: 'By business need',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Business Spend Management',
        src: '/business-spend-management-solutions'
      }, {
        text: 'Tax Management',
        src: '/benefit-tax'
      }, {
        text: 'Visibility and control',
        src: '/visibility-and-compliance'
      }, {
        text: 'Automation',
        src: '/expense-travel-invoice-automation'
      }, {
        text: 'Expense Policy',
        src: '/free-expense-management-tools'
      }, {
        text: 'Invoice Policy',
        src: '/accelerate-supplier-invoice-approval-process'
      }, {
        text: 'Productivity',
        src: '/productivity'
      }]
    }, {
      text: 'By industry',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Manufacturing',
        src: '/manufacturing'
      }, {
        text: 'Professional services',
        src: '/professional-services'
      }, {
        text: 'Retail and Restaurant',
        src: '/retail-and-restaurant'
      }]
    }, {
      text: 'By role',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Enterprise Finance Leader',
        src: '/financial-manager-solutions'
      }, {
        text: 'Small Business Finance Leader',
        src: '/modern-finance-leaders'
      }, {
        text: 'IT Leader',
        src: '/IT-leader'
      }, {
        text: 'Travel Manager',
        src: '/travel-manager'
      }]
    }, {
      text: 'Request Pricing',
      src: '/get-quote-form',
      classes: 'call-out'
    }]
  }, {
    title: {
      text: 'ABOUT US'
    },
    list: [{
      text: 'Why SAP Concur',
      src: '/why-concur'
    }, {
      text: 'Our Platform',
      src: '/concur-integrated-ecosystem'
    }, {
      text: 'Partners',
      src: '/partners'
    }, {
      text: 'Solution Provider',
      src: '/solution-provider'
    }, {
      text: 'Locations',
      src: '/contact/offices'
    }, {
      text: 'Careers',
      src: ''
    }, {
      text: 'Privacy Policy',
      src: '/privacy-policy'
    }, {
      text: 'CONTACT SALES',
      src: '/contact',
      classes: 'call-out'
    }]
  }, {
    title: {
      text: 'RESOURCES'
    },
    list: [{
      text: 'Newsroom',
      src: '/newsroom'
    }, {
      text: 'Resource Center',
      src: '/resource-center'
    }, {
      text: 'Events',
      src: '/events'
    }, {
      text: 'Case Studies',
      src: '/casestudy/index'
    }, {
      text: 'Getting Started',
      src: '/getting-started'
    }, {
      text: 'Partners',
      src: '/partners'
    }, {
      text: 'App Center',
      src: '/app-center'
    }, {
      text: 'Expense Demo',
      src: '/self-guided-demo-expense-en-ca',
      classes: 'call-out hidden-xs hidden-sm hidden-md'
    }, {
      text: 'Invoice Demo',
      src: '/self-guided-demo-invoice-en-ca',
      classes: 'call-out hidden-xs hidden-sm hidden-md'
    }]
  }],
  supportLinks: [{
    text: 'LOGIN',
    href: ''
  }, {
    text: 'SERVICE STATUS',
    href: ''
  }, {
    text: 'CONTACT SALES',
    href: '/contact'
  }, {
    text: 'REQUEST A QUOTE',
    href: '/get-quote-form'
  }, {
    text: 'SUPPORT',
    href: '/contact'
  }],
  mobileAppText: {
    text: 'GET CONCUR MOBILE APP'
  }
};